import { useState, useEffect } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import {
  doc,
  getDocs,
  query,
  collection,
  where,
  updateDoc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { db, auth } from "../../util/firebase";

import { useTranslation } from "react-i18next";

const ShopTutorialModal = (props) => {
  const { isOpen: externalIsOpen, onClose } = props || {};
  const [user] = useAuthState(auth);
  const [showTutorial, setShowTutorial] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const { t } = useTranslation("common");

  const tutorialSteps = [
    {
      image: t("step12Image"),
      text: t("step12Text"),
    },
    {
      image: t("step13Image"),
      text: t("step13Text"),
    },
    {
      image: t("step14Image"),
      text: t("step14Text"),
    },
    {
      image: t("step15Image"),
      text: t("step15Text"),
    },
  ];

  const checkTutorialStatus = async () => {
    const q = query(collection(db, "users"), where("uid", "==", user?.uid));
    const docs = await getDocs(q);
    const userDoc = docs.docs[0];
    const data = userDoc.data();

    if (!data.userHasFinishedShopTutorial) {
      setShowTutorial(true);
    }
  };

  const completeTutorial = async () => {
    const q = query(collection(db, "users"), where("uid", "==", user?.uid));
    const docs = await getDocs(q);
    const userDoc = docs.docs[0];

    const ref = doc(db, "users", userDoc.id);
    await updateDoc(ref, {
      userHasFinishedShopTutorial: true,
    });

    setShowTutorial(false);
    if (typeof onClose === "function") onClose();
  };

  useEffect(() => {
    if (user) {
      if (typeof externalIsOpen !== "undefined") {
        if (externalIsOpen) setShowTutorial(true);
        else setShowTutorial(false);
      } else {
        checkTutorialStatus();
      }
    }
    // eslint-disable-next-line
  }, [user, externalIsOpen]);

  const modalIsOpen =
    typeof externalIsOpen !== "undefined" ? externalIsOpen : showTutorial;

  return (
    <Modal isOpen={modalIsOpen} backdrop="static">
      <ModalBody style={{ padding: 0 }}>
        <img
          src={tutorialSteps[currentStep].image}
          alt={`tutorial-step-${currentStep + 1}`}
          style={{
            width: "100%",
            borderRadius: 12,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        />
        <p
          style={{
            textAlign: "center",
            marginTop: "1rem",
            paddingLeft: "1rem",
            paddingRight: "1rem",
          }}
        >
          {tutorialSteps[currentStep].text}
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
            padding: "1rem",
          }}
        >
          {currentStep === 0 ? (
            <Button
              onClick={() => setCurrentStep((prev) => prev + 1)}
              className="primaryBtn"
            >
              NEXT
            </Button>
          ) : (
            <>
              <Button
                disabled={currentStep === 0}
                onClick={() => setCurrentStep((prev) => prev - 1)}
                className="secondaryBtn"
                style={{ color: "#005EE1", width: "49%" }}
              >
                PREVIOUS
              </Button>

              {currentStep < tutorialSteps.length - 1 ? (
                <Button
                  onClick={() => setCurrentStep((prev) => prev + 1)}
                  className="primaryBtn"
                  style={{ width: "49%" }}
                >
                  NEXT
                </Button>
              ) : (
                <Button
                  onClick={completeTutorial}
                  className="primaryBtn"
                  style={{ width: "49%" }}
                >
                  FINISH
                </Button>
              )}
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ShopTutorialModal;
